var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0877 15.1241C18.8505 13.6385 19.0337 11.9322 18.6374 10.3406L21.1618 9.70955C21.9955 9.50112 22.2831 8.46283 21.6754 7.85515L16.1449 2.32457C15.5372 1.71689 14.4989 2.00448 14.2904 2.83821L13.6594 5.36256C12.74 5.13364 11.7823 5.0981 10.8511 5.25593L18.0877 15.1241Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1981 16.4474C17.0837 16.5808 16.9634 16.7108 16.8371 16.8371C16.1418 17.5324 15.3341 18.0467 14.4725 18.3801L6.56805 7.84073C6.74892 7.60513 6.94721 7.3786 7.16291 7.1629C7.80202 6.5238 8.53612 6.03759 9.31976 5.70428L17.1981 16.4474Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8988 18.7817L5.74017 9.23691C5.12387 10.634 4.998 12.1952 5.36256 13.6594L2.83821 14.2904C2.00448 14.4989 1.71689 15.5372 2.32457 16.1449L7.85515 21.6754C8.46283 22.2831 9.50112 21.9955 9.70955 21.1618L10.3406 18.6374C11.1779 18.8459 12.0469 18.894 12.8988 18.7817Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyAlt2);
export default __webpack_public_path__ + "static/media/candy-alt-2.83f089dd0346ffe8bd397842d92d7987.svg";
export { ForwardRef as ReactComponent };